import { Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutAsed from "./pages/About/AboutAsed";
import Chairmanship from "./pages/About/Chairmanship";
import Members from "./pages/Members";
import Links from "./pages/Links";
import Events from "./pages/Events/Events";
import EventDetail from "./pages/Events/EventDetail";
import Gallery from "./pages/Gallery";
import Publications from "./pages/Publications";
import Workplan from "./pages/Workplan";
import NotFound from "./NotFound";

function App() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/aboutased" component={AboutAsed} />
      <Route exact path="/chairmanship" component={Chairmanship} />
      <Route exact path="/members" component={Members} />
      <Route exact path="/links" component={Links} />

      {/* event */}
      <Route exact path="/events" component={Events} />
      <Route exact path="/events/id/:slug" component={EventDetail} />
      <Route exact path="/meetings" component={Events} />
      <Route exact path="/meetings/id/:slug" component={EventDetail} />

      {/* workplan */}
      <Route exact path="/workplan" component={Workplan} />

      <Route exact path="/gallery" component={Gallery} />
      <Route exact path="/publications" component={Publications} />
      <Route component={NotFound} />
    </Switch>
  );
}

export default App;
